import _actions_get from './_actions/get.js'
import _actions_change_page from './_actions/change_page.js'
import _getters_text_pagination from './_getters/text/pagination.js'
import _getters_row_name from './_getters/row/name.js'
import _getters_row_min from './_getters/row/min.js'
import _getters_row_method from './_getters/row/method.js'
import _getters_row_max from './_getters/row/max.js'
import _getters_setting from './_getters/setting.js'
import _mutations_set from './_mutations/set.js'
import _mutations_remove from './_mutations/remove.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        remove: _mutations_remove,
        set: _mutations_set,
    },
    getters:{
        setting: _getters_setting,
        row_max: _getters_row_max,
        row_method: _getters_row_method,
        row_min: _getters_row_min,
        row_name: _getters_row_name,
        text_pagination: _getters_text_pagination,
    },
    actions:{
        change_page: _actions_change_page,
        get: _actions_get,
    },
}